(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-title"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initialize(root) {
    root.querySelectorAll('[data-mc-title-words]').forEach(track => {
      if (track.dataset.mcTitleReady) return;
      track.dataset.mcTitleReady = 'true';
      const words = Array.from(track.children);
      if (words.length < 2) return;
      let index = 0;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const render = () => {
        track.style.transform = 'translateY(-' + words[index].offsetTop + 'px)';
      };
      const observer = new ResizeObserver(() => {
        track.style.transition = 'none';
        render();
      });
      observer.observe(track.parentElement);
      const timer = window.setInterval(() => {
        if (!track.isConnected) {
          window.clearInterval(timer);
          observer.disconnect();
          return;
        }
        if (document.hidden || reducedMotion.matches) return;
        index = (index + 1) % words.length;
        track.style.transition = 'transform 350ms ease';
        render();
      }, 3000);
      render();
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
